export default __webpack_public_path__ + "static/BusinessPhoneSystem-4121404aaa6f342514a47c36a4662663.jpeg";